<template>
  <div>
    <h5>Canceling Onboarding ...</h5>
  </div>
</template>

<script>
export default {
  async mounted() {
    localStorage.removeItem("user");
    localStorage.removeItem("company");
    localStorage.removeItem("garbage");

    this.$router.push({ path: "/" });
  },
};
</script>
